// extracted by mini-css-extract-plugin
module.exports = {"loading_background":"loading_loading_background__2Hhyj","svg":"loading_svg__2n-ay"};